export default "__VITE_ASSET__BbZ2v2i2__"